export enum Qualification {
  QualityManagement = 'quality_management',
  HygieneSpecialist = 'hygiene_specialist',
  PsychiatricNursing = 'psychiatric_nursing',
  NursingSupervisor = 'nursing_supervisor',
  UnitManager = 'unit_manager',
  WoundManagement = 'wound_management',
  OperationAndEndoscopyService = 'operation_and_endoscopy_service',
  GeriatricPsychiatry = 'geriatric_psychiatry',
  IntensiveAndAnestheticCare = 'intensive_and_anesthetic_care',
  PainNurse = 'pain_nurse',
  PediatricIntensiveAndAnestheticCare = 'pediatric_intensive_and_anesthetic_care',
  PediatricPsychiatricNursing = 'pediatric_psychiatric_nursing',
  PediatricOperationAndEndoscopyService = 'pediatric_operation_and_endoscopy_service',
  PediatricNephrology = 'pediatric_nephrology',
  PediatricOncology = 'pediatric_oncology',
  PalliativeCare = 'palliative_care',
  NursingAdvisor = 'nursing_advisor',
  HomeManager = 'home_manager',
  ResidentialSectorManager = 'residential_sector_manager',
  BasicVentilationCare = 'basic_ventilation_care',
  ExpertVentilationCare = 'expert_ventilation_care',
  Instructor = 'instructor',
  PracticeManagement = 'practice_management',
  CareAssistanceInFamily = 'care_assistance_in_family',
  NonMedicalPracticeAssistance = 'non_medical_practice_assistance',
  XrayCertificate = 'x_ray_certificate',
  OutpatientSurgery = 'outpatient_surgery',
  CaseManagement = 'case_management',
  OutpatientCareOlderPeople = 'outpatient_care_older_people',
  ProcessingMedicalDevices = 'processing_medical_devices',
  Pediatrics = 'pediatrics',
  NutritionalMedicine = 'nutritional_medicine',
  VaccinationManagement = 'vaccination_management',
  DentalProphylacticAssistance = 'dental_prophylactic_assistance',
  DentalAdministrativeAssistance = 'dental_administrative_assistance',
  DentalSpecialistAssistance = 'dental_specialist_assistance',
  DentalHygienist = 'dental_hygienist',
  DentalPracticeManagement = 'dental_practice_management',
  GeriatricPsychiatricSpecialist = 'geriatric_psychiatric_specialist',
  VentilationCertificate = 'ventilation_certificate',
  SpecialistWoundTherapist = 'specialist_wound_therapist',
  NursingAssessor = 'nursing_assessor',
  DementiaSpecialist = 'dementia_specialist',
  HygieneOfficer = 'hygiene_officer',
  IntensiveCareBasicCourse = 'intensive_care_basic_course',
  StationManagement = 'station_management',
  OncologyNurseSpecialist = 'oncology_nurse_specialist',
  SpecialistNurseInSurgicalService = 'specialist_nurse_in_surgical_service',
  SpecialistNurseInPsychiatry = 'specialist_nurse_in_psychiatry',
  SpecialistNurseInEmergencyCare = 'specialist_nurse_in_emergency_care',
  NoFurtherEducation = 'no_further_education',
  AccountingManager = 'accounting_manager',
  QualityManagementRepresentative = 'quality_management_representative',
  HygieneManager = 'hygiene_manager',
  RadiographyCourse = 'radiography_course',
}

export const QUALIFICATIONS_TRANSLATIONS = {
  [Qualification.QualityManagement]: 'Qualitätsmanagement',
  [Qualification.HygieneSpecialist]: 'Hygienefachkraft',
  [Qualification.PsychiatricNursing]: 'Psychiatrische Pflege',
  [Qualification.NursingSupervisor]: 'Pflegedienstleitung',
  [Qualification.UnitManager]: 'Stationsleitung',
  [Qualification.WoundManagement]: 'Wundmanager/in',
  [Qualification.OperationAndEndoscopyService]: 'Fachkrankenpfleger/in im Operations- und Endoskopiedienst',
  [Qualification.GeriatricPsychiatry]: 'Geriatrische Psychiatrie',
  [Qualification.IntensiveAndAnestheticCare]: 'Fachkrankenpfleger/in für Intensivpflege und Anästhesie',
  [Qualification.PainNurse]: 'Schmerzpfleger/in',
  [Qualification.PediatricIntensiveAndAnestheticCare]: 'Pädiatrische Intensivpflege und Anästhesie',
  [Qualification.PediatricPsychiatricNursing]: 'Pädiatrische Psychiatrische Pflege',
  [Qualification.PediatricOperationAndEndoscopyService]: 'Pädiatrischer Operations- und Endoskopiedienst',
  [Qualification.PediatricNephrology]: 'Pädiatrische Nephrologie',
  [Qualification.PediatricOncology]: 'Pädiatrische Onkologie',
  [Qualification.PalliativeCare]: 'Palliative Care',
  [Qualification.NursingAdvisor]: 'Pflegeberater/in',
  [Qualification.HomeManager]: 'Einrichtungsleitung',
  [Qualification.ResidentialSectorManager]: 'Wohnbereichsleitung',
  [Qualification.BasicVentilationCare]: 'Basiskurs zur außerklinischen Beatmung',
  [Qualification.ExpertVentilationCare]: 'Pflegeexperten/in für Außerklinische Intensivpflege',
  [Qualification.Instructor]: 'Praxisanleitung',
  [Qualification.PracticeManagement]: 'Praxismanagement',
  [Qualification.CareAssistanceInFamily]: 'Versorgungsassistenz in der Hausarztpraxis',
  [Qualification.NonMedicalPracticeAssistance]: 'Nichtärztliche Praxisassistenz (bzw. EVA (Entlastende Versorgungsassistenz))',
  [Qualification.XrayCertificate]: 'Röntgenschein',
  [Qualification.OutpatientSurgery]: 'Ambulantes Operieren',
  [Qualification.CaseManagement]: 'Case Management',
  [Qualification.OutpatientCareOlderPeople]: 'Ambulante Versorgung älterer Menschen',
  [Qualification.ProcessingMedicalDevices]: 'Aufbereitung von Medizinprodukten',
  [Qualification.Pediatrics]: 'Pädiatrie - Prävention im Kindes-und Jugendalter',
  [Qualification.NutritionalMedicine]: 'Ernährungsmedizin',
  [Qualification.VaccinationManagement]: 'Impfmanagement',
  [Qualification.DentalProphylacticAssistance]: 'Zahnmedizinische Prophylaxeassistenz',
  [Qualification.DentalAdministrativeAssistance]: 'Zahnmedizinische Verwaltungsassistenz',
  [Qualification.DentalSpecialistAssistance]: 'Zahnmedizinische Fachassistenz, quasi ZMP & ZMV zusammen',
  [Qualification.DentalHygienist]: 'Dentalhygieniker/in',
  [Qualification.DentalPracticeManagement]: 'Zahnärztliches Praxismanagement',
  [Qualification.GeriatricPsychiatricSpecialist]: 'Gerontopsychatrische Fachkraft',
  [Qualification.VentilationCertificate]: 'Beatmungsschein',
  [Qualification.SpecialistWoundTherapist]: 'Fachtherapeut Wunde',
  [Qualification.NursingAssessor]: 'Pflegegutachter',
  [Qualification.DementiaSpecialist]: 'Demenzfachkraft',
  [Qualification.HygieneOfficer]: 'Hygienebeauftragte',
  [Qualification.IntensiveCareBasicCourse]: 'Pflegefachkraft für außerklinische Beatmung (Basiskurs)',
  [Qualification.StationManagement]: 'Stationsleitung',
  [Qualification.OncologyNurseSpecialist]: 'Fachkrankenpfleger/in für Onkologie',
  [Qualification.SpecialistNurseInSurgicalService]: 'Fachkrankenpfleger/in Operationsdienst',
  [Qualification.SpecialistNurseInPsychiatry]: 'Fachkrankenpfleger/in Psychiatrie',
  [Qualification.SpecialistNurseInEmergencyCare]: 'Fachkrankenpfleger/in Notfallpflege',
  [Qualification.NoFurtherEducation]: 'Keine Weiterbildung',
  [Qualification.AccountingManager]: 'Abrechnungsmanagerin',
  [Qualification.QualityManagementRepresentative]: 'Qualitätsmanagement Beauftragte (QMB)',
  [Qualification.HygieneManager]: 'Hygienemanagerin',
  [Qualification.RadiographyCourse]: 'Röntgenkurs',
};
